import {
  ScrollTrigger
} from "./chunk.RYXMHMS2.js";
import {
  gsapWithCSS
} from "./chunk.LXB4MYP4.js";
import {
  Spaceable
} from "./chunk.G3SZKTQJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ChangesBackgroundColor
} from "./chunk.7ANACPIR.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n,
  r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-timeline/jb-timeline.scss?inline
var jb_timeline_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
h4 {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

p, h2 {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h2 {
  font-size: var(--theme-typo-h2-subtitle-mobile-fontsize, 1.625rem);
  line-height: var(--theme-typo-h2-subtitle-mobile-lineheight, 2.188rem);
}
@media (min-width: 1281px) {
  h2 {
    font-size: var(--theme-typo-h2-subtitle-desktop-fontsize, 1.938rem);
    line-height: var(--theme-typo-h2-subtitle-desktop-lineheight, 2.625rem);
  }
}

h4 {
  font-size: var(--theme-typo-h4-mobile-fontsize, 1.188rem);
  line-height: var(--theme-typo-h4-mobile-lineheight, 1.75rem);
}
@media (min-width: 1281px) {
  h4 {
    font-size: var(--theme-typo-h4-desktop-fontsize, 1.375rem);
    line-height: var(--theme-typo-h4-desktop-lineheight, 2.125rem);
  }
}

p {
  font-size: var(--theme-typo-p-mini-desktop-fontsize, 0.813rem);
  line-height: var(--theme-typo-p-mini-desktop-lineheight, 1.25rem);
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  --_grid-gap: 16px;
  --_columnwidth: calc((100% - (5 * var(--_grid-gap))) / 6);
  --_picturewidth: calc(2 * var(--_columnwidth) + var(--_grid-gap));
  --_timelinewidth: calc(2 * var(--spacing-l) + 1px);
  --_infowidth: 1fr;
  display: block;
}
@media (min-width: 960px) {
  :host {
    --_grid-gap: 40px;
    --_columnwidth: calc((100% - (7 * var(--_grid-gap))) / 8);
    --_picturewidth: 1fr;
    --_infowidth: calc(5 * var(--_columnwidth) + 4 * var(--_grid-gap));
  }
}

.timeline-item {
  display: block;
  margin-bottom: var(--spacing-m);
  margin-left: var(--spacing-l);
  position: relative;
  width: calc(100% - var(--spacing-l));
}
@media (min-width: 600px) {
  .timeline-item {
    display: grid;
    gap: var(--spacing-m) 0;
    grid-template-columns: var(--_picturewidth) var(--_timelinewidth) var(--_infowidth);
    margin-left: 0;
    width: 100%;
  }
}
.timeline-item:last-child .timeline-ray {
  height: calc(100% + 16px);
}

h2 {
  margin-bottom: var(--spacing-2xs);
}
@media (min-width: 600px) {
  h2 {
    grid-column: 3;
    margin-bottom: calc(-1 * var(--spacing-m));
    padding-bottom: var(--spacing-2xs);
  }
}

h4 {
  margin-bottom: var(--spacing-base);
}

jb-picture {
  opacity: 0;
  transform-origin: center left;
}
@media (min-width: 600px) {
  jb-picture {
    transform-origin: center right;
  }
}

.info {
  align-self: center;
  height: min-content;
  position: relative;
}
@media (min-width: 600px) {
  .info {
    grid-column: 3;
  }
}
.info:not(:last-child) {
  margin-bottom: var(--spacing-m);
}
@media (min-width: 600px) {
  .info:not(:last-child) {
    margin-bottom: 0;
  }
}

.infoblock {
  opacity: 0;
  transform-origin: center left;
}

.picture-wrapper {
  align-self: center;
  margin-bottom: var(--spacing-xs);
  position: relative;
}
@media (min-width: 600px) {
  .picture-wrapper {
    grid-column: 1/2;
    margin-bottom: 0;
  }
}

.timeline-ray {
  background-color: #141e55;
  height: calc(100% + 40px);
  left: calc(-1 * var(--spacing-l));
  position: absolute;
  top: 17px;
  width: 1px;
}
@media (min-width: 600px) {
  .timeline-ray {
    grid-column: 3;
  }
}
@media (min-width: 1281px) {
  .timeline-ray {
    top: 21px;
  }
}
.timeline-ray::before {
  background-color: #b0aa7e;
  border-radius: 50px;
  content: "";
  display: block;
  height: 17px;
  left: -8px;
  position: absolute;
  top: -8px;
  width: 17px;
}

.picture-wrapper .dot,
.info .dot {
  background-color: #141e55;
  border-radius: 50px;
  content: "";
  display: block;
  height: 7px;
  left: calc(-1 * var(--spacing-l) - 3px);
  opacity: 0;
  position: absolute;
  top: calc(50% - 3px);
  width: 7px;
}

.picture-wrapper + .info .dot {
  display: none;
}

@media (min-width: 600px) {
  .picture-wrapper .dot {
    display: none;
  }
  .picture-wrapper + .info .dot {
    display: block;
  }
}`;

// src/components/jb-timeline/jb-timeline.ts
var JbTimeline = class extends Spaceable(ChangesBackgroundColor(h)) {
  constructor() {
    super(...arguments);
    this.sort = "oldestFirst";
  }
  connectedCallback() {
    super.connectedCallback();
    this._timelineArray = this._groupBy(this.timelineItems, "year");
    this._timelineKeys = this.sort === "oldestFirst" ? Object.keys(this._timelineArray) : Object.keys(this._timelineArray).reverse();
  }
  async firstUpdated() {
    await this.updateComplete;
    gsapWithCSS.registerPlugin(ScrollTrigger);
    this._animatedElements.forEach((element) => {
      this._addAnimation(element);
    });
  }
  _addAnimation(element) {
    ScrollTrigger.create({
      trigger: element,
      onEnter: () => {
        this._animateElement(element);
      },
      onEnterBack: () => {
        this._animateElement(element);
      },
      onLeave: () => {
        this._hide(element);
      },
      onLeaveBack: () => {
        this._hide(element);
      }
    });
  }
  _animateElement(element) {
    gsapWithCSS.fromTo(
      element,
      { scale: 0.7, autoAlpha: 0 },
      {
        duration: 0.7,
        delay: 0.1,
        scale: 1,
        autoAlpha: 1,
        ease: "ease-in",
        overwrite: "auto"
      }
    );
  }
  _getContentSpacingProperties() {
    return { colsMdUp: 8, grid: "legacy" };
  }
  // https://stackoverflow.com/a/71505541
  _groupBy(arr, prop) {
    return arr.reduce((memo, x) => {
      if (!memo[x[prop]]) {
        memo[x[prop]] = [];
      }
      memo[x[prop]].push(x);
      return memo;
    }, {});
  }
  _hide(element) {
    gsapWithCSS.set(element, { autoAlpha: 0 });
  }
  render() {
    return this._timelineKeys.map(
      (key) => ke`<div class="timeline-item">
          <div class="timeline-ray"></div>
          <h2>${key}</h2>
          ${this._timelineArray[key].map(
        (elm) => ke`
              ${elm.image ? ke`
                    <div class="picture-wrapper">
                      <span class="dot"></span>
                      <jb-picture
                        .alt=${elm.image.alt}
                        .imgData=${elm.image.imgData}
                        .lazy=${elm.image.lazy}
                        aspect="aspect_3by2"
                        fit="cover"
                      ></jb-picture>
                    </div>
                  ` : D}
              <div class="info">
                <span class="dot"></span>
                <div class="infoblock">
                  <h4>${elm.headline}</h4>
                  <p>${elm.description}</p>
                </div>
              </div>
            `
      )}
        </div>`
    );
  }
};
JbTimeline.styles = r(jb_timeline_default);
__decorateClass([
  n()
], JbTimeline.prototype, "sort", 2);
__decorateClass([
  n({ type: Array })
], JbTimeline.prototype, "timelineItems", 2);
__decorateClass([
  r2("jb-picture, .infoblock, .dot")
], JbTimeline.prototype, "_animatedElements", 2);
JbTimeline = __decorateClass([
  customElement("jb-timeline")
], JbTimeline);

export {
  JbTimeline
};
